import React, { useEffect, useState } from "react";
import API from "../../config";
import { getCategories } from "../../api/getCategories";
import { getProducts } from "../../api/getProducts";
import { useParams, Link } from "react-router-dom";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Loader from "../../components/Loader/Loader";
import ProductCard from "../../components/RudrakshaSection/ProductCard";
import CategorySearch from "../../components/CategorySearch/CategorySearch";
import faqData from "../../data/faqData";
import { FiHeadphones, FiFilter, FiX } from "react-icons/fi";
import "./ShopCategoryPage.css";
const PAGE_SIZE = 12;

// Uploaded images come back as "/uploads/..." unless the backend serves them from a CDN.
const getSubcategoryImageSrc = (url) =>
  /^https?:\/\//.test(url) ? url : `${API.replace(/\/api\/v1\/?$/, "")}${url}`;

export default function ShopCategoryPage() {
  const { mainCategory } = useParams();
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [apiError, setApiError] = useState("");
  const [search, setSearch] = useState("");
  const [filterPopup, setFilterPopup] = useState(false);
  const [openFilter, setOpenFilter] = useState("");
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(50000);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [sortBy, setSortBy] = useState("Featured");
  const [openFaq, setOpenFaq] = useState(null);
  const toggleFilter = (name) => {
    setOpenFilter((prev) => (prev === name ? "" : name));
  };
  useEffect(() => {
    setPage(1);
    setSearch("");
    setHasLoaded(false);
  }, [mainCategory]);
  const handleSearch = (term) => {
    setSearch(term);
    setPage(1);
  };

  useEffect(() => {
  
    const controller = new AbortController();

    const fetchData = async () => {
      try {
        setLoading(true);
        setApiError("");
        const categoryResult = await getCategories();
        console.log("CATEGORY API:", categoryResult);
        if (!categoryResult?.success) {
          throw new Error(
            categoryResult?.message || "Unable to load categories",
          );
        }
        const categoryList = categoryResult.data || [];
        setCategories(categoryList);
        const normalize = (value) =>
          String(value || "")
            .trim()
            .toLowerCase()
            .replace(/\s+/g, "-");

        const matchedCategory = categoryList.find((cat) => {
          const urlSlug = normalize(mainCategory);
          return (
            normalize(cat?.slug) === urlSlug ||
            normalize(cat?.name) === urlSlug ||
            normalize(cat?.title) === urlSlug
          );
        });

        if (!matchedCategory) {
          setProducts([]);
          setPagination(null);
          return;
        }
        const productResult = await getProducts({
          categoryId: matchedCategory.id,
          search,
          page,
          limit: PAGE_SIZE,
          signal: controller.signal,
        });

        console.log("PRODUCT API:", productResult);

        if (productResult.success) {
          setProducts(productResult.data?.products || []);
          setPagination(productResult.data?.pagination || null);
        } else {
          throw new Error(productResult.message || "Unable to load products");
        }
      } catch (error) {
        if (controller.signal.aborted) return;

        console.error("Shop Category API Error:", error);

        setApiError(error.message || "Unable to load shop category");
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
          setHasLoaded(true);
        }
      }
    };

    fetchData();

    return () => controller.abort();
  }, [mainCategory, page, search]);
  const normalizeSlug = (value) =>
    String(value || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-");

  const currentCategory = categories.find((cat) => {
    const urlSlug = normalizeSlug(mainCategory);

    const categorySlug = normalizeSlug(cat?.slug);
    const categoryName = normalizeSlug(cat?.name);
    const categoryTitle = normalizeSlug(cat?.title);

    return (
      categorySlug === urlSlug ||
      categoryName === urlSlug ||
      categoryTitle === urlSlug
    );
  });
  const categoryProducts = products;
  const currentSubcategory = null;
  const formattedProducts = categoryProducts.map((product) => {
    const primaryImage =
      product.images?.find((image) => image.isPrimary) || product.images?.[0];
    return {
      ...product,
      id: product.id,
      title: product.name,
      name: product.name,
      image: primaryImage?.imageUrl ? `${API}${primaryImage.imageUrl}` : "",
      image2: primaryImage?.thumbUrl ? `${API}${primaryImage.thumbUrl}` : "",
      price: Number(product.price || 0),
      category: product.category?.name || "",
      subcategory: product.subcategory?.name || "",
      mukhi: product.mukhiCount !== undefined ? product.mukhiCount : "",
      origin: product.origin || "",
      beadSize: product.beadSizeMm || "",
      certification: product.isCertified ? "Certified" : "Not Certified",
    };
  });
  if (loading && !hasLoaded) {
    return (
      <>
        <Header />
        <div style={{ padding: "60px 20px" }}>
          <Loader label="Loading category..." />
        </div>
        <Footer />
      </>
    );
  }
  if (apiError) {
    return (
      <>
        <Header />
        <div
          style={{
            padding: "100px 20px",
            textAlign: "center",
          }}
        >
          <h2>{apiError}</h2>
        </div>
        <Footer />
      </>
    );
  }
  if (!currentCategory) {
    return (
      <>
        <Header />
        <div
          style={{
            padding: "100px 20px",
            textAlign: "center",
          }}
        >
          <h2>Category Not Found</h2>
        </div>
        <Footer />
      </>
    );
  }
  const filterMap = {
    rudrakshas: ["Mukhi", "Origin", "Bead Size", "Certification", "Price"],
    shivling: ["Origin", "Certification", "Price"],
    gemstones: ["Origin", "Bead Size", "Certification", "Price"],
    crystals: ["Origin", "Color", "Size", "Price"],
    "shankh-sea-shells": ["Origin", "Size", "Price"],
    "vastu-products": [
      "Purpose",
      "Material",
      "Direction",
      "Placement",
      "Room",
      "Price",
    ],
    tulsi: ["Product Type", "Bead Size", "Color", "Price"],
    shaligram: ["Origin", "Certification", "Price"],
    pooja: ["Product Type", "Material", "Metal", "Size", "Price"],
    perfumes: ["Origin", "Certification", "Price"],
  };

  const currentFilters = filterMap[mainCategory] || [
    "Origin",
    "Certification",
    "Price",
  ];
  const filterFieldMap = {
    Mukhi: ["mukhiCount", "mukhi", "Mukhi"],
    Origin: ["origin", "Origin"],
    "Bead Size": ["beadSizeMm", "beadSize", "size"],
    Certification: ["certification", "certificate", "isCertified"],
    Stone: ["stone", "gemstone"],
    Planet: ["planet", "rulingPlanet"],
    Color: ["color", "colour"],
    Size: ["size", "beadSizeMm"],
    "Product Type": ["productType", "type", "subcategory"],
    Purpose: ["purpose", "intention"],
    Material: ["material"],
    Direction: ["direction"],
    Placement: ["placement"],
    Room: ["room"],
    Metal: ["metal"],
  };
  const getFilterValue = (product, filterName) => {
    const keys = filterFieldMap[filterName] || [];
    for (const key of keys) {
      let value = product?.[key];
      if (key === "subcategory" && product?.subcategory) {
        value = product.subcategory.name;
      }
      if (key === "isCertified" && product?.isCertified !== undefined) {
        return product.isCertified ? "Certified" : "Not Certified";
      }
      if (
        value !== undefined &&
        value !== null &&
        value !== "" &&
        typeof value !== "object"
      ) {
        return String(value);
      }
    }
    return "";
  };
  const filterOptions = {};
  currentFilters.forEach((filter) => {
    if (filter === "Price") {
      filterOptions[filter] = [];
      return;
    }

    const values = formattedProducts
      .map((product) => getFilterValue(product, filter))
      .filter(Boolean);

    filterOptions[filter] = [...new Set(values)];
  });
  const handleFilterChange = (filterName, value) => {
    setSelectedFilters((prev) => {
      const currentValues = prev[filterName] || [];

      if (currentValues.includes(value)) {
        return {
          ...prev,

          [filterName]: currentValues.filter((item) => item !== value),
        };
      }

      return {
        ...prev,

        [filterName]: [...currentValues, value],
      };
    });
  };

  const clearAllFilters = () => {
    setSelectedFilters({});
    setMinPrice(0);
    setMaxPrice(50000);
    setOpenFilter("");
  };

  const filteredProducts = formattedProducts.filter((product) => {
    const productPrice = Number(product.price || 0);

    if (
      productPrice > 0 &&
      (productPrice < minPrice || productPrice > maxPrice)
    ) {
      return false;
    }

    for (const filterName of currentFilters) {
      if (filterName === "Price") {
        continue;
      }

      const selectedValues = selectedFilters[filterName] || [];

      if (selectedValues.length === 0) {
        continue;
      }

      const productValue = getFilterValue(product, filterName);

      const matched = selectedValues.some((value) =>
        productValue.toLowerCase().includes(value.toLowerCase()),
      );

      if (!matched) {
        return false;
      }
    }

    return true;
  });

  const sortedProducts = [...filteredProducts].sort((a, b) => {
    if (sortBy === "Alphabetically A-Z") {
      return String(a.title || "").localeCompare(String(b.title || ""));
    }

    if (sortBy === "Alphabetically Z-A") {
      return String(b.title || "").localeCompare(String(a.title || ""));
    }

    if (sortBy === "Price Low To High") {
      return Number(a.price || 0) - Number(b.price || 0);
    }

    if (sortBy === "Price High To Low") {
      return Number(b.price || 0) - Number(a.price || 0);
    }

    if (sortBy === "Date New To Old") {
      return new Date(b.createdAt) - new Date(a.createdAt);
    }

    if (sortBy === "Date Old To New") {
      return new Date(a.createdAt) - new Date(b.createdAt);
    }

    return 0;
  });

  const bannerImages = {
    rudrakshas:
      "https://res.cloudinary.com/yi3u1mel/image/upload/v1791307680/file_0000000076a0820a995b996ac4544bbe_1.png",
    shivling:
      "https://res.cloudinary.com/yi3u1mel/image/upload/v1791309621/file_000000001dc881f89b16e5edf0aea6df.png",
    gemstones:
      "https://res.cloudinary.com/yi3u1mel/image/upload/v1791223859/file_0000000094a0823098305680f0ef06c0.png",
    crystals:
      "https://res.cloudinary.com/yi3u1mel/image/upload/v1791223865/file_0000000020a88211a7ea04dd7dd20fc0.png",
    "shankh-sea-shells":
      "https://res.cloudinary.com/yi3u1mel/image/upload/v1791309619/file_000000003ed0820ba9c0fcfb1918999f.png",
    "vastu-products":
      "https://res.cloudinary.com/yi3u1mel/image/upload/v1791223866/file_00000000b51c81fa849a696d89ad7573.png",
    tulsi:
      "https://res.cloudinary.com/dbb2hkjri/image/upload/v1792833798/file_00000000d11482119f35bc58055f943b_uk0fpz.png",
    perfumes:
      "https://res.cloudinary.com/yi3u1mel/image/upload/v1791223862/file_000000008d28820b95ed98c6b40460b4.png",
    pooja:
      "https://res.cloudinary.com/yi3u1mel/image/upload/v1791223861/file_00000000466481fa9f61543420554afe.png",
    shaligram:
      "https://res.cloudinary.com/yi3u1mel/image/upload/v1791309751/file_000000004ff48209a9b1e8bd805138a4_1.png",
    "shop-by-concern":
      "https://res.cloudinary.com/dbb2hkjri/image/upload/v1792992896/file_000000004f008211a71e83910dbdee95_ediz6d.png",
    "shop-by-astrology":
      "https://res.cloudinary.com/dbb2hkjri/image/upload/v1792992892/file_00000000c4c88211a4fbb65f101f0dc5_wo452j.png",
    "shop-by-birth-number":
      "https://res.cloudinary.com/dbb2hkjri/image/upload/v1792992892/file_00000000f7488211a49107ea2c5cac32_xyuzcq.png",
  };

  let subcategories = currentCategory.subcategories || [];
  if (!subcategories || subcategories.length === 0) {
    const subcategoryMap = {};
    categoryProducts.forEach((product) => {
      if (product.subcategory && product.subcategory.id) {
        if (!subcategoryMap[product.subcategory.id]) {
          subcategoryMap[product.subcategory.id] = product.subcategory;
        }
      }
    });
    subcategories = Object.values(subcategoryMap);
  }
  return (
    <>
      <Header />
      <section className="shop-banner">
        {bannerImages[mainCategory] && (
          <img
            src={bannerImages[mainCategory]}
            alt={currentCategory.name}
            className="shop-banner-img"
          />
        )}
      </section>
      <div className="breadcrumb">
        <Link to="/">Home</Link>
        <span> / </span>
        <Link to={`/shop/${mainCategory}`}>{currentCategory.name}</Link>
        {currentSubcategory && (
          <>
            <span> / </span>

            <span>{currentSubcategory.name}</span>
          </>
        )}
      </div>
      <section className="subcategory-section">
        <div className="subcategory-slider">
          {subcategories.map((item) => (
            <Link
              key={item.id}
              to={`/shop/${mainCategory}/${item.slug}`}
              className="subcategory-card"
            >
              <div className="subcategory-image">
                {item.imageUrl ? (
                  <img
                    src={getSubcategoryImageSrc(item.imageUrl)}
                    alt={item.name}
                    loading="lazy"
                    onError={(e) => {
                      // Broken/missing file: fall back to the letter circle
                      e.currentTarget.style.display = "none";
                      e.currentTarget.nextElementSibling?.removeAttribute("hidden");
                    }}
                  />
                ) : null}
                <div
                  className="subcategory-placeholder"
                  hidden={Boolean(item.imageUrl)}
                >
                  {item.name?.charAt(0)}
                </div>
              </div>

              <h4>{item.name}</h4>
            </Link>
          ))}
        </div>
      </section>
      <section className="shop-products">
        <div className="shop-right">
          <div className="shop-topbar">
            <button
              className="top-filter-btn"
              onClick={() => setFilterPopup(true)}
            >
              <FiFilter />

              <span>FILTER</span>
            </button>

            <div className="sort-by">
              <label>SORT BY</label>

              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
              >
                <option value="Featured">Featured</option>

                <option value="Most Relevant">Most Relevant</option>

                <option value="Best Selling">Best Selling</option>

                <option value="Alphabetically A-Z">Alphabetically A-Z</option>

                <option value="Alphabetically Z-A">Alphabetically Z-A</option>

                <option value="Price Low To High">Price Low To High</option>

                <option value="Price High To Low">Price High To Low</option>

                <option value="Date New To Old">Date New To Old</option>

                <option value="Date Old To New">Date Old To New</option>
              </select>
            </div>

            <CategorySearch
              key={mainCategory}
              onSearch={handleSearch}
              placeholder={`Search in ${currentCategory.name}...`}
            />
          </div>
          <div
            className="products-grid"
            style={
              loading ? { opacity: 0.55, pointerEvents: "none" } : undefined
            }
          >
            {sortedProducts.length > 0 ? (
              sortedProducts.map((product) => (
                <ProductCard key={product.id} product={product} />
              ))
            ) : (
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  padding: "60px 20px",
                }}
              >
                <h3>
                  {search
                    ? `No products match “${search}” in ${currentCategory.name}`
                    : "No products found"}
                </h3>
              </div>
            )}
          </div>

          {pagination && pagination.pages > 1 && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "16px",
                margin: "30px 0",
              }}
            >
              <div className="pagination">
                <div className="pagination-pages">
                  {[1, 2, 3, "...", 10].map((item, index) => (
                    <button
                      key={index}
                      type="button"
                      className={`pagination-btn ${
                        page === item ? "active" : ""
                      }`}
                      disabled={item === "..."}
                      onClick={() => {
                        if (typeof item === "number") setPage(item);
                      }}
                    >
                      {item}
                    </button>
                  ))}
                </div>

              </div>
            </div>
          )}
        </div>
      </section>
      {filterPopup && (
        <div
          className="filter-popup-overlay"
          onClick={() => setFilterPopup(false)}
        >
          <div className="filter-popup" onClick={(e) => e.stopPropagation()}>
            <div className="filter-popup-header">
              <h2>Filter</h2>

              <button
                className="filter-close"
                onClick={() => setFilterPopup(false)}
              >
                <FiX />
              </button>
            </div>

            <div className="filter-category-name">
              {currentSubcategory
                ? currentSubcategory.name
                : currentCategory.name}
            </div>

            <div className="filter-popup-body">
              {currentFilters.map((filter) => (
                <div className="popup-filter-item" key={filter}>
                  <button
                    className="popup-filter-heading"
                    onClick={() => toggleFilter(filter)}
                  >
                    <span>{filter}</span>

                    <span className="popup-filter-icon">
                      {openFilter === filter ? "−" : "+"}
                    </span>
                  </button>

                  {openFilter === filter && (
                    <div className="popup-filter-content">
                      {/* PRICE */}

                      {filter === "Price" ? (
                        <div className="popup-price">
                          <div className="popup-price-labels">
                            <span>Min</span>

                            <span>Max</span>
                          </div>

                          <div className="popup-price-inputs">
                            <div className="popup-price-input">
                              <span>₹</span>

                              <input
                                type="number"
                                value={minPrice}
                                onChange={(e) =>
                                  setMinPrice(Number(e.target.value))
                                }
                                placeholder="0.00"
                              />
                            </div>

                            <div className="popup-price-input">
                              <span>₹</span>

                              <input
                                type="number"
                                value={maxPrice}
                                onChange={(e) =>
                                  setMaxPrice(Number(e.target.value))
                                }
                                placeholder="50000"
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="popup-options">
                          {filterOptions[filter]?.length > 0 ? (
                            filterOptions[filter].map((option) => (
                              <label key={option} className="popup-option">
                                <input
                                  type="checkbox"
                                  checked={(
                                    selectedFilters[filter] || []
                                  ).includes(option)}
                                  onChange={() =>
                                    handleFilterChange(filter, option)
                                  }
                                />

                                <span>{option}</span>
                              </label>
                            ))
                          ) : (
                            <div className="no-filter-options">
                              No options available
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="filter-popup-footer">
              <button className="clear-filter" onClick={clearAllFilters}>
                CLEAR ALL
              </button>

              <button
                className="apply-filter"
                onClick={() => {
                  setFilterPopup(false);
                  setOpenFilter("");
                }}
              >
                APPLY FILTER
              </button>
            </div>
          </div>
        </div>
      )}

      <section className="faq-section">
        <div className="faq-container">
          <h2 className="faq-title">Frequently Asked Questions</h2>

          {(faqData[mainCategory] || []).map((item, index) => (
            <div
              key={index}
              className={`faq-card ${openFaq === index ? "active" : ""}`}
            >
              <button
                className="faq-btn"
                onClick={() => setOpenFaq(openFaq === index ? null : index)}
              >
                <span className="faq-question">
                  Q.{index + 1}. {item.question}
                </span>

                <span className="faq-plus">
                  {openFaq === index ? "−" : "+"}
                </span>
              </button>

              {openFaq === index && (
                <div className="faq-content">
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
      <section className="support-section">
        <div className="support-content">
          <h2>Need Support? Get Consultation Now!</h2>

          <p>Need to chat with us? We are happy to assist you.</p>

        <Link to="/contact" className="support-btn">
  <FiHeadphones />
  Get Support
</Link>
        </div>
      </section>
      <Footer />
    </>
  );
}
